import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`GIPHY SDK for Web`}</h2>
    <p>{`The React SDK consists of `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md#gif"
      }}>{`Gif`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md#grid"
      }}>{`Grid`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md#carousel"
      }}>{`Carousel`}</a>{` components. It uses
the `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md"
      }}>{`Fetch API`}</a>{` to fetch data.
All React SDK components also support Server Side Rendition(SSR). Here's a `}<a parentName="p" {...{
        "href": "https://codesandbox.io/s/giphy-web-sdk-ssr-with-nextjs-irv19"
      }}>{`codesanbox`}</a>{` for an example of SSR with next.js`}</p>
    <p>{`Not using React? We have vanilla JavaScript components as well: `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/components/README.md#gif"
      }}>{`Gif`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/components/README.md#grid"
      }}>{`Grid`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/components/README.md#carousel"
      }}>{`Carousel`}</a>{`.`}</p>
    <h3>{`Installation`}</h3>
    <p>{`Install using npm or yarn:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add @giphy/react-components @giphy/js-fetch-api
`}</code></pre>
    <p>{`Checkout the github repo `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js"
      }}>{`here`}</a>{`.`}</p>
    <h3>{`Getting started`}</h3>
    <p>{`Here is a basic example of how to render a `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md#grid"
      }}>{`Grid`}</a>{` of gifs using the `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md#grid"
      }}>{`Grid`}</a>{` component and the `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md"
      }}>{`Fetch API`}</a>{`.
You'll need an API key to fetch data that will be used to populate your components. You can apply for an API key `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/dashboard/"
      }}>{`here`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { Grid } from '@giphy/react-components'
import { GiphyFetch } from '@giphy/js-fetch-api'

// use @giphy/js-fetch-api to fetch gifs, instantiate with your api key
const gf = new GiphyFetch('your api key')

// configure your fetch: fetch 10 gifs at a time as the user scrolls (offset is handled by the grid)
const fetchGifs = (offset: number) => gf.trending({ offset, limit: 10 })

// Render the React Component and pass it your fetchGifs as a prop
ReactDOM.render(<Grid width={800} columns={3} fetchGifs={fetchGifs} />, target)
`}</code></pre>
    <h3>{`See the SDK in action`}</h3>
    <p>{`Live edit our SDK components here and try it out for yourself!`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/giphyreact-components-hbmcf?from-embed"
      }}><img parentName="a" {...{
          "src": "https://codesandbox.io/static/img/play-codesandbox.svg",
          "alt": "Edit @giphy/react-components"
        }}></img></a></p>
    <h3>{`Learn more`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md"
        }}>{`Fetch API`}</a>{` - Wraps fetches to the GIPHY API and returns typed response. Fetch `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md#trending"
        }}>{`trending`}</a>{`, `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md#search"
        }}>{`search`}</a>{`,
`}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md#related"
        }}>{`related`}</a>{`, `}<a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md#emoji"
        }}>{`emoji`}</a>{` and more.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md"
        }}>{`React SDK`}</a>{` - UI Component library using React.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Giphy/giphy-js/blob/master/packages/components/README.md"
        }}>{`JavaScript SDK`}</a>{` - UI Components you can append to the DOM.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      